import React, { useState, useEffect } from "react";
import { MessageCircle, X, Send, Mail, Sparkles } from "lucide-react";

const QUICK_PROMPTS = [
  "How do I forge a new contract?",
  "Where is the Fleet Registry?",
  "How do I bind a GitHub repo?",
  "Status of my Imperial Archives?",
];

export default function SovereignAssistant() {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState("");

  // Close on Escape
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  const sendToSupport = () => {
    const body = encodeURIComponent(draft || "(Type your question for the Sovereign Assistant...)");
    window.location.href = `mailto:support@eigooinc.net?subject=Sovereign%20Assistant%20Inquiry&body=${body}`;
  };

  return (
    <>
      {/* Panel */}
      {open && (
        <div
          className="fixed bottom-24 right-6 z-[9998] w-[340px] max-w-[calc(100vw-3rem)] glass-strong p-5 space-y-4"
          data-testid="sovereign-assistant-panel"
          style={{ animation: "saSlideUp 220ms cubic-bezier(0.16, 1, 0.3, 1)" }}
        >
          <div className="flex items-start justify-between">
            <div>
              <div className="flex items-center gap-2">
                <Sparkles className="w-4 h-4 gold-text" strokeWidth={1.8} />
                <span className="label-tag gold-text">Sovereign Assistant</span>
              </div>
              <div className="text-sm font-bold mt-1">How may the Armada serve?</div>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="w-8 h-8 flex items-center justify-center border border-white/10 hover:border-white/30"
              aria-label="Close assistant"
              data-testid="sovereign-assistant-close"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </div>

          <div className="text-xs text-gray-400 leading-relaxed">
            Ask anything about contracts, fleet operations, the Forge, or signing.
            For now, queries route to <strong className="gold-text">support@eigooinc.net</strong>.
            Full AI assistant coming online in the next phase.
          </div>

          <div className="space-y-1.5" data-testid="sovereign-assistant-prompts">
            {QUICK_PROMPTS.map((p) => (
              <button
                key={p}
                onClick={() => setDraft(p)}
                className="w-full text-left text-xs px-3 py-2 border border-white/10 hover:border-[#C9A227]/40 hover:bg-[#C9A227]/5 text-gray-300 hover:text-white transition-colors"
              >
                {p}
              </button>
            ))}
          </div>

          <textarea
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="Type your question…"
            rows={3}
            className="w-full bg-black/50 border border-white/10 px-3 py-2 text-sm focus:border-[#C9A227] focus:outline-none rounded-none"
            data-testid="sovereign-assistant-input"
          />

          <div className="flex items-center gap-2">
            <button
              onClick={sendToSupport}
              className="btn-gold flex-1 inline-flex items-center justify-center gap-2 text-xs"
              data-testid="sovereign-assistant-send"
            >
              <Send className="w-3.5 h-3.5" /> Send to Armada
            </button>
            <a
              href="mailto:support@eigooinc.net"
              className="text-xs label-tag border border-white/10 hover:border-white/30 px-3 py-2.5 inline-flex items-center gap-1.5"
              data-testid="sovereign-assistant-mail"
            >
              <Mail className="w-3.5 h-3.5" />
            </a>
          </div>

          <div className="text-[9px] label-tag text-gray-500 text-center pt-2 border-t border-white/5">
            EMPOWERED BY EIGOO INC
          </div>
        </div>
      )}

      {/* Floating bubble */}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "Close Sovereign Assistant" : "Open Sovereign Assistant"}
        aria-expanded={open}
        data-testid="sovereign-assistant-toggle"
        className="fixed bottom-6 right-6 z-[9999] w-14 h-14 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-105 active:scale-95"
        style={{
          background: open ? "#0A0A0A" : "#C9A227",
          color: open ? "#C9A227" : "#0A0A0A",
          boxShadow: open
            ? "0 0 24px rgba(201, 162, 39, 0.4), 0 0 0 1px #C9A227"
            : "0 6px 24px rgba(201, 162, 39, 0.45)",
          paddingBottom: "env(safe-area-inset-bottom, 0)",
        }}
      >
        {open
          ? <X className="w-5 h-5" strokeWidth={2.2} />
          : <MessageCircle className="w-6 h-6" strokeWidth={2} fill="currentColor" />}
      </button>

      <style>{`
        @keyframes saSlideUp {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
}
